import React from 'react';
import ProfileHeader from './ProfileHeader';
import './TableauPage.css';

const TableauPage = ({ onNavigate }) => {
  return (
    <div className="tableau-page">
      <main className="main-container">
        <section className="hero-section">
          <ProfileHeader showTableauLink={false} onNavigate={onNavigate} />
        </section>
        
        <div className="tableau-container">
          <div className="tableau-download-section">
            <a 
              href="https://chromewebstore.google.com/detail/magouille-bj-tableau/mmfeickacmfcmgffciemgjpdgklpbmia"
              target="_blank"
              rel="noopener noreferrer"
              className="download-extension-btn"
              style={{ textDecoration: 'none', color: 'white' }}
            >
              Télécharger l'extension Chrome
            </a>
          </div>
          
          <img 
            src="/tableau_bj_magouille.png" 
            alt="Tableau BJ Magouille" 
            className="tableau-image"
          />
        </div>
      </main>
    </div>
  );
};

export default TableauPage;
